import React from "react";

const images = ["1.jpg", "2.jpg", "3.jpg", "4.jpg"];

export default function SmartLab() {
  return (
    <div className="bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex flex-wrap justify-center gap-4">
          {images.map((img, idx) => (
            <img
              key={idx}
              src={"/proiecte/SmartLab/poze/" + img}
              alt={`SmartLab ${idx + 1}`}
              className="w-full sm:w-64 h-64 object-cover rounded shadow"
            />
          ))}
        </div>
        <div className="w-full mt-8">
          <embed
            src="/proiecte/SmartLab/PPT SMART LAB.pdf"
            type="application/pdf"
            width="100%"
            height="800px"
          />
        </div>
      </main>
    </div>
  );
}
